import { DeliveryCompanyName, Order } from 'types/orders'

export function getTrackingUrl(order: Order): string | null {
  if (!order.trackingNumber) {
    return null
  }
  switch (order.shipmentType.deliveryCompanyName) {
    case DeliveryCompanyName.InPost:
      return `https://inpost.pl/sledzenie-przesylek?number=${order.trackingNumber}`
    case DeliveryCompanyName.DPD:
      return `https://tracktrace.dpd.com.pl/parcelDetails?typ=1&p1=${order.trackingNumber}`
    default:
      return ''
  }
}
